/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeadingThree = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 6v12h2v-5h6v5h2V6h-2v5H5V6zm12.276 10.02v1.596c.328.176.704.308 1.128.396a5.96 5.96 0 0 0 1.32.144c.696 0 1.296-.116 1.8-.348.512-.232.904-.564 1.176-.996.272-.44.408-.96.408-1.56 0-.68-.212-1.244-.636-1.692-.416-.456-1.012-.728-1.788-.816l2.064-2.112V9.396h-5.316v1.524h2.94l-2.16 2.28.588.984a3.42 3.42 0 0 1 1.224-.228c.456 0 .8.112 1.032.336.24.224.36.54.36.948 0 .432-.152.764-.456.996s-.74.348-1.308.348a5.7 5.7 0 0 1-1.236-.144 4.763 4.763 0 0 1-1.14-.42z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeadingThree as HeadingThree };
